module.exports = __webpack_public_path__ + "static/media/dentalcleaning.f3274f5b.png";